import { GridColDef } from '@mui/x-data-grid-pro'
import { TFunction } from 'i18next'
import IconButton from '@/shared/components/IconButton/IconButton'
import styles from './TablesColumns.module.scss'

export const getColumnsConfig = (
  translations: TFunction<'translation', undefined>
) => {
  const t = (key: string) => translations(key)
  const columns: GridColDef[] = [
    {
      field: 'id',
      headerName: 'ID',
      resizable: false,
      width: 44,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: styles.tableCell,
      sortable: false,
      hideSortIcons: true,
      disableColumnMenu: true,
      hideable: false,
      renderHeader: params => (
        <p className={`${styles.tableHeaderText} body-bold-medium`}>
          {params.colDef.headerName}
        </p>
      )
    },
    {
      field: 'number',
      headerName: t('TABLE.EMPLOYEES.HEADERS.NUMBER'),
      flex: 1,
      editable: false,

      hideable: false,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: styles.tableCell,
      disableColumnMenu: true,
      minWidth: 80,

      renderHeader: params => (
        <p className={`${styles.tableHeaderText} body-bold-medium`}>
          {params.colDef.headerName}
        </p>
      )
    },
    {
      field: 'room',
      headerName: t('TABLE_LIST.HEADERS.ROOM'),
      flex: 1,
      editable: false,
      hideable: false,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: styles.tableCell,
      disableColumnMenu: true,
      sortable: false,
      minWidth: 80,
      renderHeader: params => (
        <p className={`${styles.tableHeaderText} body-bold-medium`}>
          {params.colDef.headerName}
        </p>
      )
    },
    {
      field: 'action',
      resizable: false,
      width: 56,
      editable: false,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: `${styles.tableCell}`,
      disableColumnMenu: true,
      disableReorder: true,
      sortable: false,
      pinnable: true,
      minWidth: 56,
      maxWidth: 56,
      hideable: false,
      renderHeader: params => (
        <p
          className={`${styles.tableHeaderText} body-bold-medium hideRightSeparator`}
        >
          {params.colDef.headerName}
        </p>
      ),
      renderCell: () => (
        <div className={`${styles.tableActionContainer}`}>
          <IconButton
            icon="las la-trash icon-medium"
            onClick={() => null}
            color="primary"
          />
        </div>
      )
    }
  ]
  return columns
}
